import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui'

interface LoadMoreProps {
  onLoadMore: () => void
  loading?: boolean
  hasMore: boolean
}

export default function LoadMore({
  onLoadMore,
  loading,
  hasMore,
}: LoadMoreProps) {
  if (!hasMore) return null
  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
      <Button
        variant="secondary"
        iconRight={<ChevronDown size={16} />}
        loading={loading}
        onClick={onLoadMore}
      >
        Voir plus
      </Button>
    </div>
  )
}
